var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "20", height: "21", viewBox: "0 0 20 21", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M10 .83c-5.522 0-10 4.477-10 10 0 5.524 4.478 10 10 10s10-4.476 10-10c0-5.523-4.478-10-10-10zm0 18.667c-4.779 0-8.667-3.887-8.667-8.666 0-4.78 3.888-8.667 8.667-8.667s8.667 3.888 8.667 8.667-3.888 8.666-8.667 8.666z", fill: "#1A74A5" }),
    React.createElement("path", { d: "M15.55 7.606l-.943-.942L8.31 12.96l-2.617-2.616-.943.943 3.56 3.558 7.24-7.239z", fill: "#1A74A5" })
  );
});


// WEBPACK FOOTER //
// ./assets/images/svg/selected_icon.svg